webpackJsonp([3],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	/**
	 * Created by jv on 26/01/2017.
	 */
	//js
	var Shared = __webpack_require__(115);
	var LanguageManager = __webpack_require__(5);
	var utils = __webpack_require__(3);
	var StoreShared = __webpack_require__(163);
	
	//Styles
	__webpack_require__(659);
	
	$(function () {
	  info.init();
	});
	
	var info = {};
	
	(function (Info) {
	  Info.init = function () {
	    setUpPage();
	
	    LanguageManager.init(function () {
	      StoreShared.init();
	    }, Shared.defaultLocale);
	  };
	
	  function setUpPage() {
	    var infoPageHTML = $(getInfoPartialFromUrl());
	
	    var storeInfoContentEl = $("#store-info-content");
	
	    storeInfoContentEl.empty().append(infoPageHTML);
	  }
	
	  function getInfoPartialFromUrl() {
	    var locale = utils.getPathSection(1);
	    var userType = utils.getPathSection(4);
	
	    var req = __webpack_require__(362);
	
	    try {
	      var infoPageRequire = "./" + locale + "/" + userType + ".jsp";
	
	      if ($.inArray(infoPageRequire, req.keys()) !== -1) {
	        return req(infoPageRequire);
	      } else {
	        console.error("Info page [%s] doesn't exist", infoPageRequire);
	      }
	    } catch (e) {
	      console.error(e);
	    }
	
	    return null;
	  }
	})(info);
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),

/***/ 116:
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./nl-BE.json": 117
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 116;


/***/ }),

/***/ 120:
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./af": 6,
		"./af.js": 6,
		"./ar": 12,
		"./ar-dz": 7,
		"./ar-dz.js": 7,
		"./ar-ly": 8,
		"./ar-ly.js": 8,
		"./ar-ma": 9,
		"./ar-ma.js": 9,
		"./ar-sa": 10,
		"./ar-sa.js": 10,
		"./ar-tn": 11,
		"./ar-tn.js": 11,
		"./ar.js": 12,
		"./az": 13,
		"./az.js": 13,
		"./be": 14,
		"./be.js": 14,
		"./bg": 15,
		"./bg.js": 15,
		"./bn": 16,
		"./bn.js": 16,
		"./bo": 17,
		"./bo.js": 17,
		"./br": 18,
		"./br.js": 18,
		"./bs": 19,
		"./bs.js": 19,
		"./ca": 20,
		"./ca.js": 20,
		"./cs": 21,
		"./cs.js": 21,
		"./cv": 22,
		"./cv.js": 22,
		"./cy": 23,
		"./cy.js": 23,
		"./da": 24,
		"./da.js": 24,
		"./de": 26,
		"./de-at": 25,
		"./de-at.js": 25,
		"./de.js": 26,
		"./dv": 27,
		"./dv.js": 27,
		"./el": 28,
		"./el.js": 28,
		"./en-au": 29,
		"./en-au.js": 29,
		"./en-ca": 30,
		"./en-ca.js": 30,
		"./en-gb": 31,
		"./en-gb.js": 31,
		"./en-ie": 32,
		"./en-ie.js": 32,
		"./en-nz": 33,
		"./en-nz.js": 33,
		"./eo": 34,
		"./eo.js": 34,
		"./es": 36,
		"./es-do": 35,
		"./es-do.js": 35,
		"./es.js": 36,
		"./et": 37,
		"./et.js": 37,
		"./eu": 38,
		"./eu.js": 38,
		"./fa": 39,
		"./fa.js": 39,
		"./fi": 40,
		"./fi.js": 40,
		"./fo": 41,
		"./fo.js": 41,
		"./fr": 44,
		"./fr-ca": 42,
		"./fr-ca.js": 42,
		"./fr-ch": 43,
		"./fr-ch.js": 43,
		"./fr.js": 44,
		"./fy": 45,
		"./fy.js": 45,
		"./gd": 46,
		"./gd.js": 46,
		"./gl": 47,
		"./gl.js": 47,
		"./he": 48,
		"./he.js": 48,
		"./hi": 49,
		"./hi.js": 49,
		"./hr": 50,
		"./hr.js": 50,
		"./hu": 51,
		"./hu.js": 51,
		"./hy-am": 52,
		"./hy-am.js": 52,
		"./id": 53,
		"./id.js": 53,
		"./is": 54,
		"./is.js": 54,
		"./it": 55,
		"./it.js": 55,
		"./ja": 56,
		"./ja.js": 56,
		"./jv": 57,
		"./jv.js": 57,
		"./ka": 58,
		"./ka.js": 58,
		"./kk": 59,
		"./kk.js": 59,
		"./km": 60,
		"./km.js": 60,
		"./ko": 61,
		"./ko.js": 61,
		"./ky": 62,
		"./ky.js": 62,
		"./lb": 63,
		"./lb.js": 63,
		"./lo": 64,
		"./lo.js": 64,
		"./lt": 65,
		"./lt.js": 65,
		"./lv": 66,
		"./lv.js": 66,
		"./me": 67,
		"./me.js": 67,
		"./mi": 68,
		"./mi.js": 68,
		"./mk": 69,
		"./mk.js": 69,
		"./ml": 70,
		"./ml.js": 70,
		"./mr": 71,
		"./mr.js": 71,
		"./ms": 73,
		"./ms-my": 72,
		"./ms-my.js": 72,
		"./ms.js": 73,
		"./my": 74,
		"./my.js": 74,
		"./nb": 75,
		"./nb.js": 75,
		"./ne": 76,
		"./ne.js": 76,
		"./nl": 78,
		"./nl-be": 77,
		"./nl-be.js": 77,
		"./nl.js": 78,
		"./nn": 79,
		"./nn.js": 79,
		"./pa-in": 80,
		"./pa-in.js": 80,
		"./pl": 81,
		"./pl.js": 81,
		"./pt": 83,
		"./pt-br": 82,
		"./pt-br.js": 82,
		"./pt.js": 83,
		"./ro": 84,
		"./ro.js": 84,
		"./ru": 85,
		"./ru.js": 85,
		"./se": 86,
		"./se.js": 86,
		"./si": 87,
		"./si.js": 87,
		"./sk": 88,
		"./sk.js": 88,
		"./sl": 89,
		"./sl.js": 89,
		"./sq": 90,
		"./sq.js": 90,
		"./sr": 92,
		"./sr-cyrl": 91,
		"./sr-cyrl.js": 91,
		"./sr.js": 92,
		"./ss": 93,
		"./ss.js": 93,
		"./sv": 94,
		"./sv.js": 94,
		"./sw": 95,
		"./sw.js": 95,
		"./ta": 96,
		"./ta.js": 96,
		"./te": 97,
		"./te.js": 97,
		"./tet": 98,
		"./tet.js": 98,
		"./th": 99,
		"./th.js": 99,
		"./tl-ph": 100,
		"./tl-ph.js": 100,
		"./tlh": 101,
		"./tlh.js": 101,
		"./tr": 102,
		"./tr.js": 102,
		"./tzl": 103,
		"./tzl.js": 103,
		"./tzm": 105,
		"./tzm-latn": 104,
		"./tzm-latn.js": 104,
		"./tzm.js": 105,
		"./uk": 106,
		"./uk.js": 106,
		"./uz": 107,
		"./uz.js": 107,
		"./vi": 108,
		"./vi.js": 108,
		"./x-pseudo": 109,
		"./x-pseudo.js": 109,
		"./yo": 110,
		"./yo.js": 110,
		"./zh-cn": 111,
		"./zh-cn.js": 111,
		"./zh-hk": 112,
		"./zh-hk.js": 112,
		"./zh-tw": 113,
		"./zh-tw.js": 113
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 120;


/***/ }),

/***/ 362:
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./nl_BE/consumer.jsp": 678,
		"./nl_BE/library.jsp": 679,
		"./nl_BE/logopaedics.jsp": 680,
		"./nl_BE/other.jsp": 681,
		"./nl_BE/school.jsp": 682,
		"./nl_NL/consumer.jsp": 683,
		"./nl_NL/logopaedics.jsp": 684,
		"./nl_NL/other.jsp": 685,
		"./nl_NL/school.jsp": 686
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 362;


/***/ }),

/***/ 659:
259,

/***/ 678:
/***/ (function(module, exports) {

	module.exports = "<h1 class=page-title data-localize=todo.l.info_title></h1> <div style=font-size:1.6rem> <div> TODO nl_BE consumer content </div> <a href=/nl_BE/store/catalog/consumer>Go to catalog</a> </div> ";

/***/ }),

/***/ 679:
/***/ (function(module, exports) {

	module.exports = "<h1 class=page-title>Bibliotheken</h1> <div style=font-size:1.6rem> <p> Gelieve je eerst aan te melden via je <a href=\"https://mijn.bibliotheek.be/openbibid/rest/libadmin/login?next=/libadmin/fundels-bestellen\">Mijn Bibliotheek administratie-account</a>. De prijzen voor de digitale abonnementen worden onmiddellijk pro rata (voor de resterende maanden van het jaar) berekend. Wens je de jaarprijs voor de bib te kennen, dan kan je deze zelf berekenen: <a href=http://www.cultuurconnect.be/sites/default/files/atoms/files/Rekenmodule%20Fundels%20v2%202017.xlsx target=_blank>Rekenmodule Fundels 2017.xlsx</a> </p> <p> Sinds 2016 worden geen Fundels uitleenkits meer verkocht. Aankoop van fysieke boekjes om de kits verder aan te vullen is wel mogelijk. </p> </div> ";

/***/ }),

/***/ 680:
/***/ (function(module, exports) {

	module.exports = "<h1 class=page-title data-localize=todo.l.info_title></h1> <div style=font-size:1.6rem> <div> TODO nl_BE logopaedics content </div> <a href=/nl_BE/store/catalog/logopaedics>Go to catalog</a> </div> ";

/***/ }),

/***/ 681:
/***/ (function(module, exports) {

	module.exports = "<h1 class=page-title>Fundels digitaal</h1> <p style=font-size:1.6rem> Wens je als organisatie of persoon gebruik te maken van Fundels maar vind je de juiste informatie niet onmiddellijk terug? Aarzel dan niet om contact op te nemen met ons Fundels-team op 09/226 09 07 of <a href=mailto:support@fundels.com>support@fundels.com</a>. We maken voor jou graag een prijs op maat! </p> ";

/***/ }),

/***/ 682:
/***/ (function(module, exports) {

	module.exports = "<h1 class=page-title data-localize=todo.l.info_title></h1> <div style=font-size:1.6rem> <div> TODO nl_BE school content </div> <a href=/nl_BE/store/catalog/school>Go to catalog</a> </div> ";

/***/ }),

/***/ 683:
/***/ (function(module, exports) {

	module.exports = "<h1 class=page-title data-localize=todo.l.info_title></h1> <div style=font-size:1.6rem> <div> TODO nl_NL consumer content </div> <a href=/nl_NL/store/catalog/consumer>Go to catalog</a> </div> ";

/***/ }),

/***/ 684:
/***/ (function(module, exports) {

	module.exports = "<h1 class=page-title data-localize=todo.l.info_title></h1> <div style=font-size:1.6rem> <div> TODO nl_NL logopaedics content </div> <a href=/nl_NL/store/catalog/logopaedics>Go to catalog</a> </div> ";

/***/ }),

/***/ 685:
/***/ (function(module, exports) {

	module.exports = "<h1 class=page-title>Fundels digitaal</h1> <p style=font-size:1.4rem;margin-top:15px> Wens je als organisatie of persoon gebruik te maken van Fundels maar vind je de juiste informatie niet onmiddellijk terug? Aarzel dan niet om contact op te nemen met ons Fundels-team op 09/226 09 07 of <a href=mailto:support@fundels.com>support@fundels.com</a>. We maken voor jou graag een prijs op maat! </p> ";

/***/ }),

/***/ 686:
/***/ (function(module, exports) {

	module.exports = "<h1 class=page-title data-localize=todo.l.info_title></h1> <div style=font-size:1.6rem> <div> TODO nl_NL school content </div> <a href=/nl_NL/store/catalog/school>Go to catalog</a> </div> ";

/***/ })

});


// WEBPACK FOOTER //
// js/store-info.6ae05939ce9507c6924d.js